<template>
    <div class="bodyheight grid bg-gray-100 dark:bg-black relative">
        <bg-global :bgLobby="bgLobby" />

        <ul class="bodyheight overflow-auto flex flex-col gap-1 py-2 text-black dark:text-white z-10">
            <div class="uppercase text-center font-semibold mb-2">Notifications</div>
            <li v-if="!notifications.messages.length"
                class="flex items-center justify-center text-sm text-red-400 dark:text-red-200 italic">
                No notifications!
            </li>
            <li v-for="(notification, index) in notifications.messages" :key="'notifications-' + notification.id"
                class="flex flex-col mx-2 p-2 rounded"
                :class="index % 2 == 0 ? 'bg-black bg-opacity-10 dark:bg-white dark:bg-opacity-10' : 'dark:bg-white dark:bg-opacity-5'">
                <div class="text-sm text-gray-700 dark:text-inner-border">{{ toDate(notification.created_at) }}</div>
                <div class="text-sm">{{ notification.message }}</div>
            </li>
        </ul>
    </div>
</template>

<script>
import * as dayjs from 'dayjs'

export default {
    name: 'Nofitications',
    props: ['notifications', 'bgLobby'],
    methods: {
        toDate(date) {
            return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
        }
    }
}
</script>
